const Logo = () => {
  return (
    <div className="flex items-center NavbarStyle-logo">
      <img
        className="logo-icon h-36"
        src={`${process.env.PUBLIC_URL}/assets/images/logo/Logo Revaluex.png`}
        alt="REVALUEX logo"
      />
      <span className="logo-text ml-12 text-20 font-bold" style={{ color: '#E91E63' }}>
        REVALUEX
      </span>
    </div>
  );
};

export default Logo;
